import {Paper} from '@mui/material';
import Layout from '@/components/layout/main-layout';
import RedirectMessage from '@/components/ui/redirect-message';

const NotFound: React.FC = () => {
  return (
    <Layout>
      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <RedirectMessage />
      </Paper>
    </Layout>
  );
};

export default NotFound;
